import { render, staticRenderFns } from "./ResourcesResults.vue?vue&type=template&id=08805fe0&scoped=true&"
import script from "./ResourcesResults.vue?vue&type=script&lang=js&"
export * from "./ResourcesResults.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesResults.vue?vue&type=style&index=0&id=08805fe0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08805fe0",
  null
  
)

export default component.exports